// Dependencies
import { Icon } from '@iconify/react';

// Material UI Components
import Box, { BoxProps } from '@mui/material/Box';

// Internal Assets
import iconifyIcons from 'src/assets/iconifyIcons';

// Types
export interface Props extends BoxProps<typeof Icon> {
  sx?: BoxProps['sx'];
  icon: typeof iconifyIcons[keyof typeof iconifyIcons];
}

/**
 * Iconify Component
 */
export default function Iconify({ icon, sx, ...other }: Props) {
  /**
   * Check if icon not exists
   */
  if (!(icon in iconifyIcons) && !icon?.includes('flag:')) {
    console.warn(`Iconify: Icon ${icon} not found`);
  }

  /**
   * Return Icon Component
   */
  return <Box component={Icon} icon={icon} sx={{ ...sx }} {...other} />;
}
